export function formatWhatsappDisplay(value: string | null | undefined): string {
  if (!value?.trim()) return '-';

  const digits = value.replace(/\D/g, '');
  const withCountry = digits.startsWith('55') ? digits : `55${digits}`;
  const ddd = withCountry.slice(2, 4);
  const rest = withCountry.slice(4);

  if (rest.length === 9) {
    return `+55 (${ddd}) ${rest.slice(0, 5)}-${rest.slice(5)}`;
  }

  if (rest.length === 8) {
    return `+55 (${ddd}) ${rest.slice(0, 4)}-${rest.slice(4)}`;
  }

  return value.trim();
}

export function normalizeWhatsapp(value?: string): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  const digits = trimmed.replace(/\D/g, '');
  if (!digits) return null;
  if (digits.startsWith('55')) return `+${digits}`;
  return `+55${digits}`;
}
